import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const industries = [
  {
    id: 'steel',
    icon: 'ri-hammer-line',
    title: '钢铁冶金',
    tag: '高排放行业',
    color: 'from-red-500/20 to-orange-500/20',
    border: 'border-red-500/30',
    iconColor: 'text-red-400',
    image: 'https://readdy.ai/api/search-image?query=steel%20iron%20metallurgy%20industrial%20factory%20interior%20blast%20furnace%20molten%20metal%20energy%20monitoring%20carbon%20emission%20management%20modern%20industry%20professional%20photography%20dramatic%20lighting&width=560&height=340&seq=ind1&orientation=landscape',
    desc: '钢铁冶金行业是碳排放大户，面临工信部严格监管和碳配额压力。Firmai为钢铁企业提供从能耗精细化监测到碳排放全量核算的完整解决方案，助力企业合规运营与降本增效。',
    pain: ['碳排放体量大，核算复杂', '工信部申报数据繁多', '能耗成本高，节能空间大', '碳配额履约压力大'],
    solutions: ['焦炉、高炉、转炉全工序能耗监测', '碳排放核算符合GB/T 32150标准', '工信部碳排放申报数据一键生成', '余热余能回收AI优化方案'],
    stats: [{ v: '40%', l: '节能潜力' }, { v: '100%', l: '合规申报' }, { v: '3个月', l: '落地周期' }],
  },
  {
    id: 'cement',
    icon: 'ri-building-2-line',
    title: '水泥建材',
    tag: '重点监管行业',
    color: 'from-stone-500/20 to-zinc-500/20',
    border: 'border-stone-500/30',
    iconColor: 'text-stone-400',
    image: 'https://readdy.ai/api/search-image?query=cement%20concrete%20manufacturing%20plant%20industrial%20kiln%20production%20facility%20carbon%20emission%20energy%20efficiency%20monitoring%20modern%20industrial%20photography%20professional%20clean&width=560&height=340&seq=ind2&orientation=landscape',
    desc: '水泥行业工业过程排放占比高，是双碳目标重点关注行业。Firmai为水泥企业提供工业过程碳排放精准核算、窑炉能效优化和工信部合规申报全流程服务。',
    pain: ['工业过程排放核算难度高', '窑炉能效差异大', 'CBAM影响出口产品', '碳核查数据准备繁琐'],
    solutions: ['工业过程CO₂排放精确核算', '窑炉热效率AI监控优化', '产品碳足迹LCA核算（含内嵌碳）', 'CBAM出口合规数据填报支持'],
    stats: [{ v: '25%', l: '综合节能率' }, { v: '30+', l: '标杆项目' }, { v: 'CBAM', l: '出口合规' }],
  },
  {
    id: 'chemical',
    icon: 'ri-flask-line',
    title: '化工行业',
    tag: '多品类监测',
    color: 'from-lime-500/20 to-green-500/20',
    border: 'border-lime-500/30',
    iconColor: 'text-lime-400',
    image: 'https://readdy.ai/api/search-image?query=chemical%20plant%20factory%20complex%20industrial%20towers%20pipelines%20energy%20monitoring%20system%20night%20aerial%20view%20professional%20photography%20modern%20infrastructure%20carbon%20management&width=560&height=340&seq=ind3&orientation=landscape',
    desc: '化工行业排放源类型多样，监测点位复杂。Firmai为化工企业提供多品类气体排放监测、全流程碳账本管理和供应链碳足迹核算，满足行业特殊合规需求。',
    pain: ['排放源种类多，核算方法复杂', '生产工艺参数与排放强相关', '供应链碳足迹追溯难度大', '安全生产与碳管理双重要求'],
    solutions: ['多品类排放源统一监测与核算', '生产工艺参数与碳排放关联分析', '供应链全链路碳足迹追溯', 'AI安全生产监控+能耗优化'],
    stats: [{ v: '50+', l: '排放源类型' }, { v: '95%', l: '核算准确率' }, { v: '供应链', l: '全链追溯' }],
  },
  {
    id: 'power',
    icon: 'ri-flashlight-line',
    title: '电力能源',
    tag: '碳市场主体',
    color: 'from-yellow-500/20 to-amber-500/20',
    border: 'border-yellow-500/30',
    iconColor: 'text-yellow-400',
    image: 'https://readdy.ai/api/search-image?query=power%20plant%20electricity%20generation%20energy%20management%20control%20room%20multiple%20screens%20data%20monitoring%20modern%20technology%20carbon%20trading%20professional%20industrial%20photography&width=560&height=340&seq=ind4&orientation=landscape',
    desc: '电力行业是全国碳市场核心参与主体，碳配额履约压力最大。Firmai为电力企业提供MRV全流程数据支撑、碳配额管理和碳资产交易辅助决策服务。',
    pain: ['碳市场履约压力最大', 'MRV数据质量要求极高', '碳配额盈缺预测难', '煤耗与发电量实时核算需求'],
    solutions: ['发电侧能耗与排放实时监测', 'MRV全流程数据归集与核查支撑', '碳配额盈缺AI预测与管理', '碳市场交易时机辅助决策'],
    stats: [{ v: 'MRV', l: '全流程支持' }, { v: '碳配额', l: '智能管理' }, { v: '实时', l: '数据监测' }],
  },
  {
    id: 'equipment',
    icon: 'ri-settings-3-line',
    title: '装备制造',
    tag: 'AI智能化',
    color: 'from-cyan-500/20 to-sky-500/20',
    border: 'border-cyan-500/30',
    iconColor: 'text-cyan-400',
    image: 'https://readdy.ai/api/search-image?query=equipment%20manufacturing%20factory%20robotic%20assembly%20line%20precision%20machining%20CNC%20machines%20smart%20factory%20automation%20AI%20quality%20inspection%20modern%20bright%20industrial%20photography&width=560&height=340&seq=ind5&orientation=landscape',
    desc: '装备制造业是AI智能化转型的核心场景。Firmai为装备制造企业提供AI预测性运维、视觉质检、数字孪生工厂等全套工业AI解决方案，同步提供碳足迹核算和绿色制造认证支持。',
    pain: ['设备故障率高，停机损失大', '产品质量检测人工成本高', '绿色工厂认定数据准备难', '产品碳足迹核算缺少工具'],
    solutions: ['设备AI预测性运维（提前预警）', 'AI视觉质检系统（>99%准确率）', '数字孪生工厂全景可视化', '绿色工厂认定数据一键生成'],
    stats: [{ v: '60%', l: '故障率降低' }, { v: '99%', l: '质检准确率' }, { v: '绿色工厂', l: '认定辅导' }],
  },
  {
    id: 'export',
    icon: 'ri-ship-line',
    title: '外贸出口制造',
    tag: 'CBAM合规',
    color: 'from-violet-500/20 to-indigo-500/20',
    border: 'border-violet-500/30',
    iconColor: 'text-violet-400',
    image: 'https://readdy.ai/api/search-image?query=export%20manufacturing%20factory%20shipping%20containers%20port%20customs%20CBAM%20European%20carbon%20border%20adjustment%20mechanism%20compliance%20trade%20global%20supply%20chain%20professional%20photography&width=560&height=340&seq=ind6&orientation=landscape',
    desc: '面向欧盟等出口的制造企业受到CBAM碳边境调节机制的直接影响。Firmai提供CBAM合规全流程服务，从产品碳足迹核算到欧盟官方平台填报，帮助外贸企业顺利应对绿色贸易壁垒。',
    pain: ['CBAM政策复杂，难以独立应对', '产品内嵌碳计算方法不熟悉', '欧盟填报系统语言与格式壁垒', '供应商排放数据收集困难'],
    solutions: ['CBAM适用性评估与差距分析', '产品内嵌碳精确核算（多语言）', '欧盟CBAM官方系统对接填报', '供应商碳数据采集与管理'],
    stats: [{ v: 'CBAM', l: '一站式合规' }, { v: '100%', l: '申报成功率' }, { v: '多语言', l: '报告输出' }],
  },
  {
    id: 'park',
    icon: 'ri-community-line',
    title: '工业园区',
    tag: '双碳数字化',
    color: 'from-teal-500/20 to-emerald-500/20',
    border: 'border-teal-500/30',
    iconColor: 'text-teal-400',
    image: 'https://readdy.ai/api/search-image?query=industrial%20park%20aerial%20view%20solar%20panels%20green%20energy%20smart%20management%20carbon%20neutral%20zone%20sustainable%20development%20digital%20infrastructure%20modern%20professional%20photography%20bird%20eye%20view&width=560&height=340&seq=ind7&orientation=landscape',
    desc: '工业园区是实现双碳目标的重要载体。Firmai为园区管委会提供统一的能碳管理平台，整合入园企业数据，支持园区级碳核算、碳达峰路径规划和低碳/零碳园区认定申报。',
    pain: ['入园企业数据分散，统计难度大', '园区碳核算缺少统一平台', '低碳园区认定申报材料繁琐', '碳达峰路径规划缺少数据支撑'],
    solutions: ['入园企业碳排放统一监测汇总', '园区级碳账本与碳达峰路径分析', '低碳/零碳园区认定数据支撑', 'CCER碳资产开发与收益管理'],
    stats: [{ v: '50+', l: '园区项目' }, { v: '园区级', l: '碳核算' }, { v: 'CCER', l: '资产开发' }],
  },
];

export default function IndustryPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (id) {
      const idx = industries.findIndex((ind) => ind.id === id);
      if (idx !== -1) setActive(idx);
    }
  }, [id]);

  const cur = industries[active];

  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-28 pb-14 overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,217,163,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }} />
          </div>
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10 text-center">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-firmai-green/10 border border-firmai-green/25 text-firmai-green text-xs font-semibold mb-5">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-building-4-line" /></span>
              覆盖7大重点工业行业
            </span>
            <h1 className="font-display font-bold text-3xl md:text-5xl text-white mb-4">
              行业解决方案<br />
              <span className="bg-gradient-to-r from-firmai-green to-teal-400 bg-clip-text text-transparent">专属定制 · 深度落地</span>
            </h1>
            <p className="text-firmai-text text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
              针对钢铁、水泥、化工、电力、装备制造、外贸出口、工业园区等重点行业的特殊需求，提供深度定制的工业双碳+AI智能化解决方案
            </p>
          </div>
        </section>

        {/* Industry Grid + Detail */}
        <section className="pb-20 bg-firmai-darker">
          <div className="w-full px-4 md:px-8 lg:px-12">
            {/* Industry Tabs */}
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2 mb-10">
              {industries.map((ind, idx) => (
                <button
                  key={ind.id}
                  onClick={() => setActive(idx)}
                  className={`flex flex-col items-center gap-2 p-3 rounded-xl border transition-all duration-300 cursor-pointer ${
                    active === idx
                      ? 'bg-firmai-green/10 border-firmai-green/40 text-firmai-green'
                      : 'bg-firmai-card border-firmai-border text-firmai-text hover:border-firmai-green/25 hover:text-white'
                  }`}
                >
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className={`${ind.icon} text-xl`} />
                  </span>
                  <span className="text-xs font-medium text-center leading-tight">{ind.title}</span>
                </button>
              ))}
            </div>

            {/* Detail Panel */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
              <div>
                <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-firmai-card border ${cur.border} ${cur.iconColor} text-xs font-semibold mb-4`}>
                  <span className="w-4 h-4 flex items-center justify-center"><i className={cur.icon} /></span>
                  {cur.tag}
                </span>
                <h2 className="text-white font-bold text-2xl md:text-3xl mb-3">{cur.title}行业解决方案</h2>
                <p className="text-firmai-text text-sm md:text-base leading-relaxed mb-6">{cur.desc}</p>

                {/* Stats */}
                <div className="flex flex-wrap gap-3 mb-6">
                  {cur.stats.map((s) => (
                    <div key={s.l} className="bg-firmai-card border border-firmai-border rounded-lg px-4 py-3 text-center">
                      <div className="text-firmai-green font-bold text-base">{s.v}</div>
                      <div className="text-firmai-muted text-xs mt-0.5">{s.l}</div>
                    </div>
                  ))}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                  <div className="bg-firmai-card border border-firmai-border rounded-xl p-4">
                    <h3 className="text-firmai-muted text-xs font-semibold uppercase tracking-wider mb-3">行业痛点</h3>
                    <ul className="space-y-2">
                      {cur.pain.map((p) => (
                        <li key={p} className="flex items-start gap-2 text-sm text-firmai-text">
                          <span className="w-4 h-4 flex items-center justify-center text-red-400 shrink-0 mt-0.5">
                            <i className="ri-close-circle-line text-xs" />
                          </span>
                          {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="bg-firmai-card border border-firmai-border rounded-xl p-4">
                    <h3 className="text-firmai-muted text-xs font-semibold uppercase tracking-wider mb-3">Firmai解决方案</h3>
                    <ul className="space-y-2">
                      {cur.solutions.map((s) => (
                        <li key={s} className="flex items-start gap-2 text-sm text-firmai-text">
                          <span className="w-4 h-4 flex items-center justify-center text-firmai-green shrink-0 mt-0.5">
                            <i className="ri-check-line text-xs" />
                          </span>
                          {s}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  获取{cur.title}专属方案
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
                </a>
              </div>

              <div className="rounded-xl overflow-hidden border border-firmai-border h-64 md:h-80 w-full">
                <img src={cur.image} alt={cur.title} className="w-full h-full object-cover object-top" />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}